import React from "react";
import { Form, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

function TextareaField({
  name,
  value,
  label,
  alternativeLabel,
  rows,
  handleBlur,
  error,
  required,
  placeholderTransKey,
  setFieldValue
}) {
  const { t } = useTranslation();

  const updateFieldValue = value => {
    setFieldValue(name, value);
  };

  return (
    <>
      {alternativeLabel}
      <Form.TextArea
        name={name}
        label={label}
        value={value}
        required={required}
        rows={rows}
        onChange={evt => {
          updateFieldValue(evt.target.value);
        }}
        onBlur={handleBlur}
        error={!!error}
        placeholder={t(placeholderTransKey)}
      />
      {error && <Message error content={error} />}
    </>
  );
}

export default React.memo(TextareaField);
